import { useQuery } from '@tanstack/react-query'
import { useContext, useEffect } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { StoresContext } from '../../../provider/StoreProvider'

import useParamId from '../../../hooks/useParamId'

import { getDisclosureDetail } from '../../../api/disclosure'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { CenterWrap } from '../../../components/common'
import { DivideLine } from '../../../components/divide'
import { Header } from '../../../components/header'
import { Spinner } from '../../../components/spinner/Spinner'
import { ArtipioContentsHeader, ArtipioContents, ArtipioContentItem } from '../../../components/contents'

export function DisclosureDetail() {
  const {
    commonStore: { setShowTab },
  } = useContext(StoresContext)

  const paramId = useParamId()

  const {
    data: disclosureDetail,
    isPending,
    isError,
  } = useQuery({
    queryKey: [QUERY_KEY.disclosureDetail, paramId],
    queryFn: async () => await getDisclosureDetail(paramId as number),
    enabled: typeof paramId === 'number',
  })

  useEffect(() => {
    setShowTab(false)
  }, [])

  if (isPending || isError) {
    return (
      <Wrap>
        <Header type="SUB" />
        <CenterWrap>
          <Spinner />
        </CenterWrap>
      </Wrap>
    )
  }

  return (
    <Wrap>
      <Header type="SUB" />
      <StyledContent isLastImg={disclosureDetail.contents[disclosureDetail.contents.length - 1].type === 'image'}>
        <ArtipioContentsHeader>
          <ArtipioContentsHeader.Title>{disclosureDetail.title ?? '-'}</ArtipioContentsHeader.Title>
          <ArtipioContentsHeader.Date>
            {dayjs(disclosureDetail.createdDate).format('YYYY.MM.DD')}
          </ArtipioContentsHeader.Date>
        </ArtipioContentsHeader>
        <DivideLine isShort={true} space={24} />
        <ArtipioContents>
          {disclosureDetail.contents.map(({ type, content, prop }, index) => {
            const isFirstImg = type === 'image' && index === 0
            const isLastImg = type === 'image' && index === disclosureDetail.contents.length - 1
            return (
              <ArtipioContentItem
                key={index}
                type={type}
                content={content}
                prop={prop}
                alt={disclosureDetail.title}
                isFirstImg={isFirstImg}
                isLastImg={isLastImg}
              />
            )
          })}
        </ArtipioContents>
      </StyledContent>
    </Wrap>
  )
}

const StyledContent = styled(Content)<{ isLastImg: boolean }>`
  ${({ isLastImg }) => (isLastImg ? '' : 'padding-bottom: 108px;')}
`
